import LayerGroup from "ol/layer/Group";
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import OSM from "ol/source/OSM";
import Annotation from "@/utils/annotation";
import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";
import TileState from "ol/TileState";
import {store} from "@/store";

export default class MapComparison {
    constructor() {
        this.annotation = new Annotation();
        this.map = null;
        this.swipe = null;
        this.resetLayersSecond();
        this.annotation.annotationLayer.setZIndex(5);
        this.rightMapLayer = new LayerGroup({
            id: 'right',
            visible: true,
            title: 'Right Layer',
            layers: [
                this.annotation.annotationLayer,
                new TileLayer({
                    id: 'thermal',
                    zIndex: 4,
                    opacity: this.getNaviLayerByValue('thermal', this.layersSecond).transparency,
                    title: "サーマルオルソ画像",
                    visible: this.getNaviLayerByValue('thermal', this.layersSecond).visible,
                    extend: [
                        this.getNaviLayerByValue('thermal', this.layersSecond).bound1Lng,
                        this.getNaviLayerByValue('thermal', this.layersSecond).bound1Lat,
                        this.getNaviLayerByValue('thermal', this.layersSecond).bound2Lng,
                        this.getNaviLayerByValue('thermal', this.layersSecond).bound2Lat,
                    ],
                    source: new XYZ({
                        attributions: "",
                        url: this.getNaviLayerByValue('thermal', this.layersSecond).mapUrl,
                        tileSize: [256, 256],
                    }),
                }),
                new TileLayer({
                    id: 'color',
                    zIndex: 3,
                    opacity: this.getNaviLayerByValue('color', this.layersSecond).transparency,
                    visible: this.getNaviLayerByValue('color', this.layersSecond).visible,
                    title: "RGBオルソ画像",
                    extend: [
                        this.getNaviLayerByValue('color', this.layersSecond).bound1Lng,
                        this.getNaviLayerByValue('color', this.layersSecond).bound1Lat,
                        this.getNaviLayerByValue('color', this.layersSecond).bound2Lng,
                        this.getNaviLayerByValue('color', this.layersSecond).bound2Lat,
                    ],
                    source: new XYZ({
                        attributions: "",
                        url: this.getNaviLayerByValue('color', this.layersSecond).mapUrl,
                        tileSize: [256, 256],
                    }),
                }),
                new LayerGroup({
                    id: 'basic',
                    layers: [
                        new TileLayer({
                            id: 'Satellite',
                            zIndex: 1,
                            title: "Satellite",
                            opacity: this.getNaviLayerByValue('basic', this.layersSecond).satellite.transparency,
                            visible: this.getNaviLayerByValue('basic', this.layersSecond).satellite.visible,
                            source: new OSM({
                                minZoom: 17,
                                maxZoom: 17,
                                url: '/api/tiles/{z}/{x}/{y}',
                                tileLoadFunction: (tile, src) => {
                                    const xhr = new XMLHttpRequest();
                                    xhr.responseType = 'blob';
                                    xhr.addEventListener('loadend', function () {
                                        const data = this.response;
                                        if (data !== undefined) {
                                            tile.getImage().src = URL.createObjectURL(data);
                                        } else {
                                            tile.setState(TileState.ERROR);
                                        }
                                    });
                                    xhr.addEventListener('error', function () {
                                        tile.setState(TileState.ERROR);
                                    });
                                    xhr.open('GET', src);
                                    xhr.setRequestHeader('Authorization', `Bearer ${store.state.token}`);
                                    xhr.send();
                                }
                            }),
                        }),
                        new TileLayer({
                            id: 'OpenStreetMap',
                            zIndex: 0,
                            title: "OpenStreetMap",
                            opacity: this.getNaviLayerByValue('basic', this.layersSecond).openStreetMap.transparency,
                            visible: this.getNaviLayerByValue('basic', this.layersSecond).openStreetMap.visible,
                            source: new OSM(),
                        }),
                    ]
                }),
            ],
        });
        this.rerenderMap = null;
        this.translateLayer = null;
    }

    init(map, swipe, rerenderMap, translateLayer){
        this.map = map;
        this.swipe = swipe;
        this.rerenderMap = rerenderMap;
        this.translateLayer = translateLayer;
    }

    updateLayersSecond(data){
        if (data["color"]) {
            this.setMapLayerLocation(this.getNaviLayerByValue('color', this.layersSecond), data["color"]);
        }
        if (data["thermal"]) {
            this.setMapLayerLocation(this.getNaviLayerByValue('thermal', this.layersSecond), data["thermal"]);
        }
        this.resetRightMapLayer();
        // this.translateLayer('color', 1);
        // this.translateLayer('thermal', 1);
    }

    resetRightMapLayer() {
        this.getLayerById('right', this.map).getLayers().getArray().forEach((layer) => {
            switch (layer.get('id')) {
                case 'thermal':
                case 'color':
                    layer.setOpacity(this.getNaviLayerByValue(layer.get('id'), this.layersSecond).transparency);
                    layer.setVisible(this.getNaviLayerByValue(layer.get('id'), this.layersSecond).visible);
                    layer.setExtent([
                        this.getNaviLayerByValue(layer.get('id'), this.layersSecond).bound1Lng,
                        this.getNaviLayerByValue(layer.get('id'), this.layersSecond).bound1Lat,
                        this.getNaviLayerByValue(layer.get('id'), this.layersSecond).bound2Lng,
                        this.getNaviLayerByValue(layer.get('id'), this.layersSecond).bound2Lat,
                    ]);
                    layer.setSource(
                        new XYZ({
                            attributions: "",
                            url: this.getNaviLayerByValue(layer.get('id'), this.layersSecond).mapUrl,
                            tileSize: [256, 256],
                        })
                    );
                    break;
                case 'basic':
                    layer.getLayers().getArray()[0].setOpacity(this.getNaviLayerByValue('basic', this.layersSecond).satellite.transparency);
                    layer.getLayers().getArray()[0].setVisible(this.getNaviLayerByValue('basic', this.layersSecond).satellite.visible);
                    layer.getLayers().getArray()[1].setOpacity(this.getNaviLayerByValue('basic', this.layersSecond).openStreetMap.transparency);
                    layer.getLayers().getArray()[1].setVisible(this.getNaviLayerByValue('basic', this.layersSecond).openStreetMap.visible);
                    break;
            }
        });
    }

    resetLayersSecond() {
        this.layersSecond = [
            {
                text: "アノテーション",
                value: "annotation",
                transparency: 100,
                visible: true,
            },
            {
                text: "サーマルオルソ画像",
                value: "thermal",
                transparency: 100,
                visible: false,
                mapUrl: "",
                bound1Lng: 0,
                bound1Lat: 0,
                bound2Lng: 0,
                bound2Lat: 0,
                lat_translate: 0,
                lng_translate: 0,
            },
            {
                text: "RGBオルソ画像",
                value: "color",
                transparency: 100,
                visible: false,
                mapUrl: "",
                bound1Lng: 0,
                bound1Lat: 0,
                bound2Lng: 0,
                bound2Lat: 0,
                lat_translate: 0,
                lng_translate: 0,
            },
            {
                openStreetMap: {
                    transparency: 100,
                    visible: true,
                    text: "OpenStreetMap",
                    value: 'OpenStreetMap',
                },
                satellite: {
                    transparency: 100,
                    visible: true,
                    text: "Mapbox",
                    value: 'Satellite',
                },
                visible: true,
                text: "ベースマップ",
                value: "basic",
            },
        ];
    }

    setMapLayerLocation(layer, ddMapPlan) {
        layer.mapUrl = ddMapPlan.path;
        layer.bound1Lng = ddMapPlan.bound_1_lng;
        layer.bound1Lat = ddMapPlan.bound_1_lat;
        layer.bound2Lng = ddMapPlan.bound_2_lng;
        layer.bound2Lat = ddMapPlan.bound_2_lat;
        layer.lat_translate = ddMapPlan.lat_translate;
        layer.lng_translate = ddMapPlan.lng_translate;
        layer.visible = true;
    }

    addEventToRightLayer(){
        this.rerenderMap(1, this.swipe, false);
    }

    setAnnotationSource(data){
        const features = data.panel_abnormality.list.map(item => {
            return {
                type: "Feature",
                id: item.id,
                properties: {
                    type: item.type,
                    reason: item.reason,
                },
                geometry: {
                    type: "Point",
                    coordinates: item.coordinates,
                },
            }
        });
        const rawSource = {
            type: "FeatureCollection",
            features: features,
        };
        const source = new VectorSource({
            features: new GeoJSON().readFeatures(rawSource),
        });
        this.getLayerById('annotation', this.getLayerById('right', this.map)).setSource(source);
    }

    closeComparison(){
        this.getLayerById('right', this.map).setVisible(false);
        this.resetLayersSecond();
        this.resetRightMapLayer();
    }

    openComparison(){
        this.resetLayersSecond();
        this.getLayerById('right', this.map).setVisible(true);
    }

    getLayerById(id, fromLayer){
        const layers = fromLayer.getLayers().getArray();
        for (const layer of layers) {
            if (layer.get("id") === id){
                return layer;
            }
            else{
                if (layer instanceof LayerGroup){
                    const a = this.getLayerById(id, layer);
                    if (a) return a;
                }
            }
        }
        return null;
    }

    getNaviLayerByValue(value, layers){
        for (const layer of layers){
            if (layer.value === value){
                return layer;
            }
        }
        return null;
    }
}
